module.exports = __webpack_public_path__ + "img/illustration-step-1-03.8c827b25.svg";